<template>
    <Loading v-bind:show="showLoadingTrocaTurma">
        <PageTitle title="PAM - Troca de Turma" />
        <Grid v-if="dadosAba && $featureToggle && $featureToggle.INTEGRA_PAM_TROCATURMA"
              v-bind:Data="dadosAba.trocaTurma"
              v-bind:Header="headerTrocaTurma"
              Name="TrocaTurma"
              Title="Total"
              OrderBy="data"
              v-bind:HeaderDetalhes="null"
              v-bind:DetalhesCombo1="dadosAba.periodo"
              v-bind:DetalhesCombo2="null"
              v-bind:DetalhesCombo3="null" />
    </Loading>
</template>

<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Pam from '@/services/PamService.js';

    export default {
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
            this.pamService = new Pam(this);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.PamTrocaTurma) {
                        this.dadosAba = a.Pam;
                    }
                    else {
                        this.showLoadingTrocaTurma = true;
                        this.dadosAba = this.trocaTurma();
                    }
                }
                else
                    this.$router.push('home');
            }

        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.PamTrocaTurma = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                headerTrocaTurma: [
                    {
                        Titulo: "Periodo",
                        Field: "pelcod",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Data Mudança Turma",
                        Field: "data",
                        Width: "100px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Turma Origem",
                        Field: "turmaOrigem",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Turma Destino",
                        Field: "turmaDestino",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Motivo",
                        Field: "motivo",
                        Width: "400px",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null,
                showLoadingTrocaTurma: false
            }
        },
        methods: {
            trocaTurma() {
                if (this.$featureToggle.INTEGRA_PAM_TROCATURMA) {
                this.showLoadingTrocaTurma = true;
                this.pamService.ConsultaTrocaTurmaPam({
                    codigoAluno: this.aluno.codigoAluno,
                    codigoEspecialidade: this.aluno.codigoEspecialidade
                }).then(
                    data => {
                        if (data.ok) {
                            this.dadosAba = data.dados;
                        }
                        else {
                            this.$modal.alert(data.mensagem);
                        }
                    },
                    error => {
                        this.$modal.error('Ocorreu um erro ao tentar buscar os dados.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                    }).finally(() => {
                        this.showLoadingTrocaTurma = false;
                    });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
